import {PropsWithChildren, useEffect, useState} from 'react'

import classNames from 'classnames/bind'

import Styles from '$components/common/static-fixed-area.module.scss'

const cx = classNames.bind(Styles)

export default function StaticFixedArea({
    height = 56,
    children,
    showShadowLine = false,
}: PropsWithChildren<{height?: number; showShadowLine?: boolean}>) {
    // [D] 헤더영역이 플로팅 될 경우, div.article에 floating 클래스 적용 및 {children} 컨텐츠 높이값을 div.article에는 paddingTop으로, div.inner에는 height로 적용
    const [isScroll, setIsScroll] = useState(false)

    // 스크롤 이벤트시, 쉐도우 라인 show
    useEffect(() => {
        if (!showShadowLine) {
            return
        }

        let clearId: NodeJS.Timeout

        const onScroll = () => {
            if (clearId) {
                clearTimeout(clearId)
            }

            clearId = setTimeout(() => {
                setIsScroll(false)
            }, 500)

            if (window.scrollY < 1) {
                return
            }
            setIsScroll(true)
        }

        window.addEventListener('scroll', onScroll)
        return () => {
            window.removeEventListener('scroll', onScroll)
        }
    }, [showShadowLine])

    return (
        <div className={cx('article', 'floating')} style={{paddingTop: height}}>
            <div className={cx('inner', {scroll: isScroll})} style={{height}}>
                {children}
            </div>
        </div>
    )
}
